import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { RepositoryFactory } from "repository/RepositoryFactory";
import algoliasearch from "algoliasearch";
import { createNullCache } from "@algolia/cache-common";
import { v4 as uuidv4 } from "uuid";
const client = algoliasearch("GPYJEAVUBP", "b1f999bc5b264defe930762391d240c6", {
  responsesCache: createNullCache(),
});
let User = RepositoryFactory.get("user");

export const orderLoader = (val) => async (dispatch) => {
  dispatch({
    type: "ORDERS_LOADER",
    payload: val,
  });
};

export const addOrderAction =
  (payload, onSuccess, onError) => async (dispatch) => {
    const orderId = uuidv4();

    try {
      dispatch(orderLoader(true));

      // 1. Fetch highest existing orderNum
      const snapshot = await firebase
        .firestore()
        .collection("orders")
        .orderBy("orderNum", "desc")
        .limit(1)
        .get();

      let maxOrderNum = 1000; // fallback if no order yet
      if (!snapshot.empty) {
        const doc = snapshot.docs[0];
        maxOrderNum = doc.data().orderNum || 1000;
      }

      const newOrderNum = maxOrderNum + 1;

      // 2. Create full order payload
      const orderPayload = {
        ...payload,
        orderId,
        orderNum: newOrderNum,
        createdAt: firebase.firestore.Timestamp.now(),
      };

      // 3. Save to DB
      const orderRef = firebase.firestore().collection("orders").doc(orderId);
      await orderRef.set(orderPayload);

      onSuccess();

      return orderId;
    } catch (error) {
      console.error("Order submission error:", error);
      toast.error(
        "Something went wrong while placing your order. Please try again."
      );
      onError(error.message);
    } finally {
      dispatch(orderLoader(false));
    }
  };

// Check inactive restaurant accounts
export const fetchOrdersForWaiter = (waiterID) => async (dispatch) => {
  try {
    const db = firebase.firestore();
    const ordersRef = db.collection("orders");

    // Calculate start and end of today (local timezone)
    const now = new Date();
    const startOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    );
    const endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59
    );

    const querySnapshot = await ordersRef
      .where("waiterID", "==", waiterID)
      .where("status", "in", ["pending", "processing", "served"])
      .where("orderType", "==", "dinein")
      .where(
        "createdAt",
        ">=",
        firebase.firestore.Timestamp.fromDate(startOfDay)
      )
      .where("createdAt", "<=", firebase.firestore.Timestamp.fromDate(endOfDay))
      .orderBy("createdAt", "desc")
      .get();

    const orders = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    dispatch({ type: "SET_WAITER_ORDERS", payload: orders });
  } catch (error) {
    console.error("Error fetching waiter orders:", error);
    dispatch({ type: "FETCH_ORDERS_ERROR", payload: error.message });
  }
};

export const fetchOrdersForWaiter111 = (waiterID) => async (dispatch) => {
  try {
    const db = firebase.firestore();
    const ordersRef = db.collection("orders");

    const querySnapshot = await ordersRef
      .where("waiterID", "==", waiterID)
      .where("status", "in", ["pending", "processing", "served"])
      .where("orderType", "==", "dinein")
      .get();

    const orders = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Optional: Dispatch to Redux store
    dispatch({ type: "SET_WAITER_ORDERS", payload: orders });
  } catch (error) {
    console.error("Error fetching waiter orders:", error);
    dispatch({ type: "FETCH_ORDERS_ERROR", payload: error.message });
  }
};

export const setToOrder = (order) => {
  const updatedOrderArray = order.order.map((item) => ({
    ...item,
    orderItemID: uuidv4(),
  }));

  return {
    type: "SET_TO_ORDER",
    payload: {
      ...order,
      order: updatedOrderArray,
    },
  };
};

export const addItemToOrder = (item) => ({
  type: "ADD_ITEM_TO_ORDER",
  payload: item,
});

export const incrementItemQuantity = (orderItemID) => ({
  type: "INCREMENT_ITEM_QUANTITY",
  payload: orderItemID,
});

export const decrementItemQuantity = (orderItemID) => ({
  type: "DECREMENT_ITEM_QUANTITY",
  payload: orderItemID,
});

export const addOrUpdateNewAddon = (orderItemID, addon) => {
  return {
    type: "ADD_OR_UPDATE_NEW_ADDON",
    payload: { orderItemID, addon },
  };
};

export const incrementAddonQuantity = ({ orderItemID, addonID }) => ({
  type: "INCREMENT_ADDON_QUANTITY",
  payload: { orderItemID, addonID },
});

export const decrementAddonQuantity = ({ orderItemID, addonID }) => ({
  type: "DECREMENT_ADDON_QUANTITY",
  payload: { orderItemID, addonID },
});

export const removeItem = (orderItemID) => ({
  type: "REMOVE_ITEM",
  payload: orderItemID,
});

export const emptyOrder = () => ({
  type: "EMPTY_ORDER",
});

export const updateOrderByOrderId =
  (updatedData, onSuccess, onError) => async (dispatch) => {
    try {
      dispatch({ type: "ORDER_UPDATE_LOADING", payload: true });

      const orderId = updatedData.orderId; // Extract orderId from payload
      if (!orderId) {
        throw new Error("Missing orderId in updatedData.");
      }

      const ordersRef = firebase.firestore().collection("orders");

      const snapshot = await ordersRef.where("orderId", "==", orderId).get();

      if (snapshot.empty) {
        console.error("No order found with orderId:", orderId);
        dispatch({ type: "UPDATE_ORDER_ERROR", payload: "No order found." });
        return;
      }

      const docRef = snapshot.docs[0].ref;

      await docRef.update({
        ...updatedData,
        updatedAt: firebase.firestore.Timestamp.now(), // Optional timestamp
      });

      onSuccess();
    } catch (error) {
      console.error("Error updating order:", error);
      dispatch({ type: "UPDATE_ORDER_ERROR", payload: error.message });
      onError();
    } finally {
      dispatch({ type: "ORDER_UPDATE_LOADING", payload: false });
    }
  };

export const updateOrderPaymentStatus =
  (orderId, paymentMethod, paymentRecieved, onSuccess, onError) =>
  async (dispatch) => {
    try {
      if (!orderId || !paymentMethod) {
        throw new Error(
          "Missing required parameters: orderId or paymentMethod."
        );
      }

      const ordersRef = firebase.firestore().collection("orders");

      const snapshot = await ordersRef.where("orderId", "==", orderId).get();

      if (snapshot.empty) {
        console.error("No order found with orderId:", orderId);
        return;
      }

      const docRef = snapshot.docs[0].ref;

      await docRef.update({
        paymentMethod,
        paymentRecieved,
        status: "completed",
        updatedAt: firebase.firestore.Timestamp.now(),
      });

      const docId = snapshot.docs[0].id;
      dispatch({
        type: "UPDATE_ORDER_STATUS",
        payload: { id: docId, status: "completed" },
      });

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Error updating order payment status:", error);
      dispatch({ type: "UPDATE_ORDER_ERROR", payload: error.message });
      if (onError) onError();
    } finally {
      dispatch({ type: "ORDER_UPDATE_LOADING", payload: false });
    }
  };

export const deleteOrderAction = (orderId) => async (dispatch) => {
  try {
    await firebase.firestore().collection("orders").doc(orderId).delete();
  } catch (error) {
    console.error("Failed to delete order:", error);
  }
};

export const markOrderpaymentRecieved = (orderId) => async (dispatch) => {
  try {
    const orderRef = firebase.firestore().collection("orders").doc(orderId);
    await orderRef.update({
      paymentRecieved: true,
      createdAt: firebase.firestore.Timestamp.now(), // optional
    });
  } catch (error) {
    console.error("Failed to update order payment status:", error);
  }
};

export const addPaymentAction = (payload) => async (dispatch) => {
  const paymentId = uuidv4();
  try {
    const paymentData = {
      ...payload,
      paymentId,
      createdAt: firebase.firestore.Timestamp.now(),
    };

    await firebase.firestore().collection("payments").add(paymentData);
  } catch (error) {
    console.error("Failed to save payment:", error);
    toast.error("Failed to record payment. Please try again.");
  }
};

export const getOrderById = (id) => async (dispatch) => {
  try {
    const orderSnapshot = await firebase
      .firestore()
      .collection("orders")
      .doc(id)
      .get();
    if (orderSnapshot.exists) {
      const order = orderSnapshot.data();
      dispatch({ type: "GET_ORDER_BY_ID", payload: order });
    }
  } catch (error) {
    console.error("Error getting order:", error);
  }
};

export const getfilterOrdersAction =
  (search, hitsPerPage, currentPage, startDate, endDate) =>
  async (dispatch) => {
    try {
      dispatch(orderLoader(true));
      const orderIndex = client.initIndex("orders");

      try {
        const response = await orderIndex.search("", {
          filters: `restaurantID:${search} AND createdAt._seconds > ${startDate} AND createdAt._seconds < ${endDate} AND NOT status:"refunded"`,
          hitsPerPage,
          page: currentPage,
        });

        let { hits, ...rest } = response;

        dispatch({ type: "GET_ALL_ORDERS", payload: hits });
        dispatch({ type: "GET_ALL_REST_ORDERS", payload: rest });
      } catch (error) {
        console.error("Error fetching orders:", error);
      }

      dispatch(orderLoader(false));
    } catch (err) {
      console.error("Error in getfilterOrdersAction:", err);
      toast.error(err.message);
      dispatch(orderLoader(false));
    }
  };

export const getRestaurantCurrency = (id) => async (dispatch) => {
  let restaurantCurrency = "";
  firebase
    .firestore()
    .collection("users")
    .doc(id)
    .onSnapshot((query) => {
      if (query) {
        let data = query.data();
        restaurantCurrency = data?.currency;
      }
      dispatch({
        type: "RESTAURANT_CURRENCY",
        payload: restaurantCurrency,
      });
    });
};

export const orderPaymentRefund =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch(refundLoading(true));
      const updateOrderAndDriver = async () => {
        await firebase.firestore().collection("orders").doc(payload.id).update({
          status: "refunded",
        });
        if (payload?.orderType === "delivery" && payload?.driverId) {
          await firebase
            .firestore()
            .collection("users")
            .doc(payload?.driverId)
            .update({
              isAssigned: false,
            });
        }
      };
      if (payload?.paymentMethod === "cash") {
        await updateOrderAndDriver()
          .then(() => {
            toast.success("Order Refunded Successfully");
            onSuccess();
            dispatch(refundLoading(false));
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message || "Error updating data");
            dispatch(refundLoading(false));
          });
      } else {
        await User.paymentRefundCard(payload)
          .then(async () => {
            await updateOrderAndDriver()
              .then(() => {
                toast.success("Order Refunded Successfully");
                onSuccess();
                dispatch(refundLoading(false));
              })
              .catch((err) => {
                toast.error(
                  err?.response?.data?.message || "Error updating data"
                );
                dispatch(refundLoading(false));
              });
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message || "Refund failed");
            dispatch(refundLoading(false));
          });
      }
    } catch (error) {
      dispatch(refundLoading(false));
      toast.error(error?.message || "An unexpected error occurred");
    }
  };

export const assignedDriverToOrder =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(assignDriverLoader(true));
    try {
      const orderRef = firebase
        .firestore()
        .collection("orders")
        .doc(payload?.orderId);

      // First get the current order to check for existing driver
      const orderDoc = await orderRef.get();
      const currentOrder = orderDoc.data();

      // If there's an existing driver, update their status
      if (currentOrder?.driverId) {
        await firebase
          .firestore()
          .collection("users")
          .doc(currentOrder.driverId)
          .update({
            isAssigned: false,
            lastAssignedAt: firebase.firestore.Timestamp.now(),
          })
          .catch((err) => {
            console.error("Error updating previous driver status:", err);
            // Don't fail the entire operation if this update fails
          });
      }

      // Now update the order with the new driver
      await orderRef.update({
        driverId: payload?.driverId,
        assignedAt: firebase.firestore.Timestamp.now(),
      });

      // Update the new driver's status
      await firebase
        .firestore()
        .collection("users")
        .doc(payload?.driverId)
        .update({
          isAssigned: true,
          lastAssignedAt: firebase.firestore.Timestamp.now(),
        });

      toast.success("Order Assigned to Driver Successfully");
      dispatch(assignDriverLoader(false));
      onSuccess();
    } catch (error) {
      console.error("Error assigning driver:", error);
      toast.error(error?.message || "Failed to assign driver");
      dispatch(assignDriverLoader(false));
    }
  };

const assignDriverLoader = (data) => async (dispatch) => {
  dispatch({
    type: "DRIVER_LOADER",
    payload: data,
  });
};

const refundLoading = (data) => async (dispatch) => {
  dispatch({
    type: "REFUND_LOADER",
    payload: data,
  });
};

export const getTotalAmount =
  (search, startDate, endDate) => async (dispatch) => {
    try {
      const orderIndex = client.initIndex("orders");

      const response = await orderIndex.search("", {
        filters: `restaurantID:${search} AND createdAt._seconds > ${startDate} AND createdAt._seconds < ${endDate} AND NOT status:"refunded"`,
        page: 0,
        attributesToRetrieve: ["totalAmount"],
      });

      const totalAmount = response.hits.reduce((acc, order) => {
        return acc + (order.totalAmount || 0);
      }, 0);

      dispatch({ type: "SET_TOTAL_AMOUNT", payload: totalAmount });
    } catch (error) {
      console.error("Error fetching total amount:", error);
      dispatch({ type: "SET_TOTAL_AMOUNT", payload: 0 });
    }
  };

export const updateOrderItemNotes = (orderItemID, notes) => ({
  type: "UPDATE_ORDER_ITEM_NOTES",
  payload: { orderItemID, notes },
});
